export const queryKeys = {
  profile: {
    current: () => ["profile", "current"] as const,
  },
  campaigns: {
    list: () => ["campaigns", "list"] as const,
    byId: (campaignId: string) => ["campaigns", "detail", campaignId] as const,
    byShortId: (shortId: string, asPlayer = false) =>
      ["campaigns", "short-id", shortId, asPlayer ? "as-player" : "actual"] as const,
    joinInfo: (shortId: string) => ["campaigns", "join-info", shortId] as const,
    publicJoinInfo: (shortId: string) => ["campaigns", "public-join-info", shortId] as const,
  },
  mapNotes: {
    list: (campaignId: string, asPlayer = false) =>
      ["map-notes", "list", campaignId, asPlayer ? "as-player" : "actual"] as const,
  },
  mapNoteTemplates: {
    list: () => ["map-note-templates", "list"] as const,
    detail: (templateId: string) => ["map-note-templates", "detail", templateId] as const,
    entries: (templateId: string) => ["map-note-templates", "entries", templateId] as const,
  },
  mapNoteEntries: {
    root: (mapNoteId: string, audience: string, asPlayer = false) =>
      ["map-note-entries", "root", mapNoteId, audience, asPlayer ? "as-player" : "actual"] as const,
    detail: (entryId: string) => ["map-note-entries", "detail", entryId] as const,
    children: (parentEntryId: string) => ["map-note-entries", "children", parentEntryId] as const,
  },
  campaignNotes: {
    root: (campaignId: string, audience: string = "gm", asPlayer = false) =>
      [
        "campaign-notes",
        "root",
        campaignId,
        audience,
        asPlayer ? "as-player" : "actual",
      ] as const,
    detail: (noteId: string) => ["campaign-notes", "detail", noteId] as const,
    children: (parentNoteId: string) =>
      ["campaign-notes", "children", parentNoteId] as const,
  },
  tileCatalog: {
    payload: () => ["tile-catalog", "payload"] as const,
  },
  feedback: {
    issues: () => ["feedback", "issues"] as const,
    comments: (issueId: string) => ["feedback", "comments", issueId] as const,
  },
  admin: {
    create: {
      workspace: () => ["admin", "create", "workspace"] as const,
    },
    tiles: {
      workspace: () => ["admin", "tiles", "workspace"] as const,
    },
    users: {
      list: () => ["admin", "users", "list"] as const,
    },
  },
} as const;
